export default (function (any) {
  if (typeof any === 'string' || any === null || any === undefined) {
    return any;
  }
  return any();
});